import React, { useCallback } from 'react';
import { DemoButton as GameDemoButton, PlayButton as GamePlayButton } from '@theme/js/components/common/Game/Buttons'; /* Lugano changes */
import { usePortletConfig } from '@core/js/components/system/Portlet';
import { useGetTrackLaunchGameFromBI } from '@core/js/components/main/Games/BICategories';

export const withLaunchGameProps = ({ mode }) => Wrapped => (props) => {
    const { reactPortletId: container, queryString } = usePortletConfig();
    const trackLaunchGameFromBI = useGetTrackLaunchGameFromBI();
    const { code, gameFeed } = props; /* Lugano changes */

    const onGameLaunched = useCallback(() => {
        if (!mode) {
            return;
        }

        trackLaunchGameFromBI(code);
    }, [trackLaunchGameFromBI, code]);

    return (
        <Wrapped
            {...props}
            {...queryString && { queryString }}
            container={container}
            gameFeed={gameFeed}
            onGameLaunched={onGameLaunched}
        />
    );
};

export const PlayButton = withLaunchGameProps({ mode: 1 })(GamePlayButton);

export const DemoButton = withLaunchGameProps({ mode: 0 })(GameDemoButton);
